'use strict';

export default function getMoreNews (url, limit, offset)
{
    var listItems = jQuery('#news-list .news-card');
    if (offset === null){
        offset = listItems.length;
    }
    var lastNewsBlock = $('.news-card').last();

    jQuery.ajax({
        method: "POST",
        url: url,
        data: {limit:limit, offset: offset}
    }).done(function (data) {
        var top = pageYOffset;
        jQuery('#news-list').append(data.news);
        $([document.documentElement, document.body]).animate({
            scrollTop: $(lastNewsBlock).offset().top = top
        }, 0);

        if (data.count < limit) {
            jQuery('button.show-more').hide();
        }
    });
}
